import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    StyledButtonSave,
    StyledButtonShare
} from 'listing-details/components/Buttons/Buttons.styles';

export const StyledUserActions = styled('div')<{ isStacked?: boolean }>(
    ({ theme: { spacing, colors }, isStacked }) => css`
        display: flex;
        background-color: ${colors['grey-alabaster']};
        padding: ${spacing['16px']};

        ${isStacked &&
        `
            flex-direction: column;

            ${StyledButtonSave} {
                order: -1;
                margin-bottom: ${spacing['8px']};
            }
        `};

        ${!isStacked &&
        `
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin: 0 -${spacing['8px']};
            background-color: ${colors['transparent']};
            padding: 0;

            ${StyledButtonSave}, ${StyledButtonShare} {
                margin: 0 ${spacing['8px']};
                width: 100%;
            }
        `};
    `
);

export const StyledUserActionsGallery = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;

        ${StyledButtonShare} {
            margin-right: ${spacing['8px']};
        }
    `
);
